"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    redeemReward: ()=>redeemReward,
    putRewardGrantActivate: ()=>putRewardGrantActivate,
    getRedeemRewards: ()=>getRedeemRewards,
    getVisits: ()=>getVisits,
    getDesiredActions: ()=>getDesiredActions,
    useRedeemRewards: ()=>useRedeemRewards,
    useGetRedeemRewards: ()=>useGetRedeemRewards,
    useGetVisits: ()=>useGetVisits,
    useActivateRewardGrant: ()=>useActivateRewardGrant,
    useDesiredActions: ()=>useDesiredActions,
    postClaimGiftCard: ()=>postClaimGiftCard,
    useClaimGiftCard: ()=>useClaimGiftCard,
    useOffersScreen: ()=>useOffersScreen
});
const _reactQuery = require("react-query");
const _react = require("react");
const _lodash = require("lodash");
const _ = require("../..");
const redeemReward = (data, opts)=>{
    const { wallet_id , ...payload } = data;
    return _.api.post(`/wallet/v1/members/${wallet_id}/redemptions`, payload, opts);
};
const putRewardGrantActivate = ({ wallet_id , reward_grant_id  })=>{
    const payload = {
        active: true
    };
    return _.api.put(`/wallet/v1/members/${wallet_id}/reward_grants/${reward_grant_id}`, payload);
};
const getRedeemRewards = async ({ id  }, opts)=>{
    const response = await _.api.get(`/native_app/v1/reward_redemptions?member_id=${id}`, opts);
    return response;
};
const getVisits = async ({ id  }, opts)=>{
    const response = await _.api.get(`/native_app/v1/visits?member_id=${id}`, opts);
    return response;
};
const getDesiredActions = async (wallet_id, opts)=>{
    const response = await _.api.get(`wallet/v2/members/${wallet_id}/wallet_actions`, opts);
    return response;
};
const useRedeemRewards = (queryOptions = {})=>{
    const { walletId , firebaseToken  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((payload)=>redeemReward({
            reward_id: payload.reward_id,
            reward_grant_id: payload.reward_grant_id,
            redemption_location: payload.redemption_location,
            wallet_id: walletId,
            firebaseToken
        }), queryOptions);
};
const useGetRedeemRewards = (queryOptions = {})=>{
    const { member  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useQuery)('redeemedRewards', ({ signal  })=>getRedeemRewards({
            id: member?.id
        }, {
            signal
        }), queryOptions);
};
const useGetVisits = (queryOptions = {})=>{
    const { member  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useQuery)('visits', ({ signal  })=>getVisits({
            id: member?.id
        }, {
            signal
        }), queryOptions);
};
const useActivateRewardGrant = (queryOptions = {})=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)((rewardGrantId)=>putRewardGrantActivate({
            wallet_id: walletId,
            reward_grant_id: rewardGrantId
        }), queryOptions);
};
const useDesiredActions = ()=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useQuery)('wallet_actions', ({ signal  })=>getDesiredActions(walletId, {
            signal
        }));
};
const postClaimGiftCard = async ({ wallet_id , reward_grant_id  })=>{
    return _.api.post(`/wallet/v1/members/${wallet_id}/reward_grants/${reward_grant_id}/claim_gift_card`);
};
const useClaimGiftCard = (queryOptions = {})=>{
    const { walletId  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useMutation)(({ reward_grant_id  })=>postClaimGiftCard({
            reward_grant_id: reward_grant_id,
            wallet_id: walletId
        }), queryOptions);
};
const useOffersScreen = ()=>{
    const [rewardGrants, setRewardGrants] = (0, _react.useState)([]);
    const [successRedeem, setSuccessRedeem] = (0, _react.useState)(null);
    const [rewardActiveId, setRewardActiveId] = (0, _react.useState)();
    const [showAlert, setShowAlert] = (0, _react.useState)({
        status: false,
        id: null
    });
    const { mutateAsync: activateRewardGrant , data  } = useActivateRewardGrant();
    const { refetch: refetchDesiredActions , data: desiredActions , isLoading: isLoadingDesiredActions  } = useDesiredActions();
    const { refetch: onRefresh , isLoading: isLoadingUsers  } = (0, _.useGetMember)();
    const { mutate: redeemReward , data: redeemData  } = useRedeemRewards();
    const { member , walletId  } = (0, _.useSpringBigStore)();
    const claimGiftCard = useClaimGiftCard();
    const { redeemOfferInStore  } = (0, _.useAppSettings)();
    const refreshOffers = (0, _react.useCallback)(()=>{
        if (member && walletId) {
            onRefresh();
            refetchDesiredActions();
        }
    }, [
        member,
        walletId,
        onRefresh,
        refetchDesiredActions
    ]);
    (0, _react.useEffect)(()=>{
        if (data) {
            setRewardActiveId(data.id);
        }
    }, [
        data
    ]);
    (0, _react.useEffect)(()=>{
        if (!member) {
            return;
        }
        if (!member.reward_grants) {
            return;
        }
        setRewardGrants((0, _lodash.orderBy)(member.reward_grants, [
            'redemptions_available'
        ], 'desc'));
    }, [
        member
    ]);
    (0, _react.useEffect)(()=>{
        if (!redeemData) {
            return;
        }
        const { expiration  } = rewardGrants.find((el)=>el.reward.id === redeemData.reward.id) || {};
        setSuccessRedeem({
            ...redeemData,
            expires: expiration || ''
        });
    }, [
        redeemData
    ]);
    const handleAcceptRedeemReward = (0, _react.useCallback)((id, title)=>{
        setShowAlert({
            status: true,
            id,
            title
        });
    }, []);
    const handleCancelRedeem = (0, _react.useCallback)(()=>{
        setShowAlert({
            status: false,
            id: null,
            title: undefined
        });
    }, []);
    const handleAcceptRedeem = (0, _react.useCallback)(()=>{
        setShowAlert((prevState)=>({
                ...prevState,
                status: false,
                title: undefined
            }));
        redeemReward({
            reward_grant_id: showAlert.id,
            redemption_location: redeemOfferInStore ? 'store' : 'online'
        });
    }, [
        showAlert
    ]);
    const [loadingActivation, setLoadingActivation] = (0, _react.useState)(false);
    const handleBonusRewards = async (rewardGrantId)=>{
        setLoadingActivation(true);
        try {
            await activateRewardGrant(rewardGrantId);
            await onRefresh();
        } finally{
            setLoadingActivation(false);
        }
    };
    return {
        rewardGrants,
        successRedeem,
        rewardActiveId,
        loadingActivation,
        refetchDesiredActions,
        isLoadingDesiredActions,
        onRefresh: refreshOffers,
        isLoadingUsers,
        handleAcceptRedeemReward,
        handleCancelRedeem,
        handleAcceptRedeem,
        handleBonusRewards,
        member,
        redeemReward,
        redeemData,
        showAlert,
        setShowAlert,
        setSuccessRedeem,
        isLoading: isLoadingDesiredActions || isLoadingUsers,
        redeemOfferInStore,
        desiredActions,
        claimGiftCard
    };
};
